import SkeIconfontWOFF from '../assets/SkeIconfont.woff';

export default {
  style: {
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    fontStyle: 'normal',
    fontWeight: 'normal',
    speak: 'none',
    display: 'inline-block',
    transform: 'translate(0, 0)',
    textRendering: 'auto',
    fontSize: 'inherit',
  },
  fontFace: {
    fontFamily: '"SkeIconfont"',
    src: [
      `url("${SkeIconfontWOFF}") format("woff")`,
    ].join(', '),
  },
  icons: { 
    'AccountChild': '\uea01', 
    'AccountEnk': '\uea02', 
    'AccountMultiple': '\uea03', 
    'Add': '\uea04', 
    'AddOutline': '\uea05', 
    'ArrowBack': '\uea06', 
    'ArrowDown': '\uea07', 
    'ArrowForward': '\uea08', 
    'ArrowUp': '\uea09', 
    'ArrowUpDown': '\uea0a', 
    'AttachFile': '\uea0b', 
    'Avgift': '\uea0c', 
    'AvgiftBedrift': '\uea0d', 
    'Bell': '\uea0e', 
    'Blocked': '\uea0f', 
    'BookOpen': '\uea10', 
    'BookOpenOutline': '\uea11', 
    'Bookmark': '\uea12', 
    'Briefcase': '\uea13', 
    'Calculator': '\uea14', 
    'Calendar': '\uea15', 
    'CalendarClock': '\uea16', 
    'Cancel': '\uea17', 
    'CashRefund': '\uea18', 
    'ChatBubbleOutline': '\uea19', 
    'Chatbot': '\uea1a', 
    'Check': '\uea1b', 
    'ChevronDown': '\uea1c', 
    'ChevronLeft': '\uea1d', 
    'ChevronRight': '\uea1e', 
    'ChevronUp': '\uea1f', 
    'CircleDown': '\uea20', 
    'CircleFilled': '\uea21', 
    'CircleRing': '\uea22', 
    'CircleUp': '\uea23', 
    'Cloud': '\uea24', 
    'CloudUpload': '\uea25', 
    'Code': '\uea26', 
    'Company': '\uea27', 
    'Completed': '\uea28', 
    'Copy': '\uea29', 
    'Delete': '\uea2a', 
    'Deploy': '\uea2b', 
    'Description': '\uea2c', 
    'Down': '\uea2d', 
    'Download': '\uea2e', 
    'Dupliser': '\uea2f', 
    'Earth': '\uea30', 
    'Edit': '\uea31', 
    'Ekteskap': '\uea32', 
    'Email': '\uea33', 
    'Error': '\uea34', 
    'ErrorOutline': '\uea35', 
    'ExcelFile': '\uea36', 
    'EyeOff': '\uea37', 
    'EyeOutline': '\uea38', 
    'Facebook': '\uea39', 
    'Familie': '\uea3a', 
    'Favorite': '\uea3b', 
    'File': '\uea3c', 
    'FileOutline': '\uea3d', 
    'Filter': '\uea3e', 
    'Folkeregister': '\uea3f', 
    'FormatAlignLeft': '\uea40', 
    'FormatAlignRight': '\uea41', 
    'Forum': '\uea42', 
    'Hammer': '\uea43', 
    'HelpFilled': '\uea44', 
    'HelpOutline': '\uea45', 
    'HelpSimple': '\uea46', 
    'History': '\uea47', 
    'Home': '\uea48', 
    'Info': '\uea49', 
    'InfoOutline': '\uea4a', 
    'InfoSimple': '\uea4b', 
    'Key': '\uea4c', 
    'Kroner': '\uea4d', 
    'LanPending': '\uea4e', 
    'Linkedin': '\uea4f', 
    'ListAdd': '\uea50', 
    'ListRemove': '\uea51', 
    'ListReorder': '\uea52', 
    'Lock': '\uea53', 
    'LockOpen': '\uea54', 
    'LockOutline': '\uea55', 
    'LockOutlineOpen': '\uea56', 
    'Menu': '\uea57', 
    'MenuDown': '\uea58', 
    'MenuUp': '\uea59', 
    'More': '\uea5a', 
    'MoveUp': '\uea5b', 
    'OpenInNew': '\uea5c', 
    'PDFFile': '\uea5d', 
    'PauseOutline': '\uea5e', 
    'Pencil-off': '\uea5f', 
    'Person': '\uea60', 
    'PersonMore': '\uea61', 
    'PersonMoreOutline': '\uea62', 
    'PersonOutline': '\uea63', 
    'Phone': '\uea64', 
    'Pin': '\uea65', 
    'Pinoff': '\uea66', 
    'PlayOutline': '\uea67', 
    'PreviewFile': '\uea68', 
    'Print': '\uea69', 
    'Save': '\uea6a', 
    'Search': '\uea6b', 
    'Send': '\uea6c', 
    'Settings': '\uea6d', 
    'Share': '\uea6e', 
    'Skattetrekk': '\uea6f', 
    'Soknad': '\uea70', 
    'SortAsc': '\uea71', 
    'SortDefault': '\uea72', 
    'SortDesc': '\uea73', 
    'SortDown': '\uea74', 
    'SortUp': '\uea75', 
    'TaOppgave': '\uea76', 
    'TemaAndreForhold': '\uea77', 
    'TemaArbeidTrygdPensjon': '\uea78', 
    'TemaBankLaanForsikring': '\uea79', 
    'TemaBoligEiendeler': '\uea7a', 
    'TemaChatbot': '\uea7b', 
    'TemaDriftsmidler': '\uea7c', 
    'TemaDrosjeServering': '\uea7d', 
    'TemaEiendelerEgenkapitalGjeld': '\uea7e', 
    'TemaFamilie': '\uea7f', 
    'TemaFinans': '\uea80', 
    'TemaGaveArv': '\uea81', 
    'TemaInntekt': '\uea82', 
    'TemaKredittfradrag': '\uea83', 
    'TemaMvaFastsetting': '\uea84', 
    'TemaMvaRegistreringer': '\uea85', 
    'TemaNaringsinntekt': '\uea86', 
    'TemaPersoninntekt': '\uea87', 
    'TemaPersonligeForhold': '\uea88', 
    'TemaSelskapDeltakerfastsetting': '\uea89', 
    'TemaSkogfond': '\uea8a', 
    'TemaUtgift': '\uea8b', 
    'TemaVarelagerFordringer': '\uea8c', 
    'Timelapse': '\uea8d', 
    'Timeline': '\uea8e', 
    'Timersand': '\uea8f', 
    'Twitter': '\uea90', 
    'Up': '\uea91', 
    'Update': '\uea92', 
    'Upload': '\uea93', 
    'VerticalDots': '\uea94', 
    'VerticalDotsCircle': '\uea95', 
    'VerticalDotsCircleSolid': '\uea96', 
    'Warning': '\uea97', 
    'WarningOutline': '\uea98', 
    'WordFile': '\uea99', 
    'XMLFile': '\uea9a' 
  }
};
